import { render, staticRenderFns } from "./EditCorporate.vue?vue&type=template&id=03a2b8a1"
import script from "./EditCorporate.vue?vue&type=script&lang=js"
export * from "./EditCorporate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports